import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IQuestionnaire, QuestionnaireType } from "../../../../documaker/domain/format/objects";

export interface IQuestionnairePropertyEditable {
  questionnaire(): IPropertyEditable<IQuestionnaire>;
  selectableQuestionnaireTypes(): (QuestionnaireType | undefined)[];
}

export function instanceOfIQuestionnairePropertyEditable(instance: any): instance is IQuestionnairePropertyEditable {
  return instance
      && instance.questionnaire
      && typeof instance.questionnaire === "function"
      && instanceOfIPropertyEditable<IQuestionnaire>(instance.questionnaire());
}
